module.exports = __webpack_public_path__ + "img/pcs-logo198x99.7e98e60d.png";